import axios from 'axios'
import { LOGIN_ENDPOINT, FORGET_ENDPOINT, FORGET_CLIENT_ENDPOINT,/* FORGET_DRIVER_ENDPOINT, */ RESET_ENDPOINT, RESET_DRIVER_ENDPOINT, RESET_CLIENT_ENDPOINT, CLIENT_LOGIN_ENDPOINT } from '../../endpoints'

export const state = {
  currentUser: null,
  isClient: false,
  clientID: null,
  userID: null,
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
  },
  SET_USER_ID(state, newValue) {
    state.userID = newValue
  },
  SET_CLIENT_ID(state, newValue) {
    state.clientID = newValue
  },
  SET_CLIENT_PROFILE(state, newValue) {
    state.isClient = newValue
  },
  SET_USER_ROLE(state,newValue){
    state.role = newValue
  }
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },

  getUserId(state) {
    return state.userID
  },

  getCurrentUser(state) {
    return state.currentUser
  },

  userProfile(state) {
    return !!state.isClient
  },

  // Client Obj
  getClientId(state) {
    return state.clientID
  },

  getUserRole(state){
    return state.role
  }
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    // @TODO: Anything?
  },

  // Logs in the current user.
  logIn({ commit, dispatch }, { username, password } = {}) {
    return axios.post(LOGIN_ENDPOINT, { username, password }).then(response => {
      const user = response.data
      let token = response.data

      // Decode JWT token to get User ID
      const jwtJsDecode = require('jwt-js-decode');
      let jwt = jwtJsDecode.jwtDecode(token.token);
      let id = jwt.payload.id
      let role = jwt.payload.role
      commit('SET_USER_ID', id)
      commit('SET_CURRENT_USER', user)
      commit('SET_USER_ROLE',role)
      return user
    })
  },

  // Logs in the Client.
  clientLogIn({ commit, dispatch }, { email, password } = {}) {
    return axios.post(CLIENT_LOGIN_ENDPOINT, { email, password }).then(response => {
      const user = response.data
      // // console.log(user.client_id)
      commit('SET_CURRENT_USER', user)
      commit('SET_CLIENT_ID', user.client_id)
      commit('SET_CLIENT_PROFILE',true)
      return user
    })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_USER_ID', null)
    commit('SET_CURRENT_USER', null)
    commit('SET_CLIENT_PROFILE',false)
    commit('SET_CLIENT_ID',null)
    commit('SET_USER_ROLE',null)
  },

  forget({ commit,dispatch },{ username} = {}){
    return axios.post(FORGET_ENDPOINT, { username }).then(response => {
      const user = response.data
      // console.log(user)
      // commit('SET_CURRENT_USER', user)
      return user
    })
  },
  forgetClient({ commit,dispatch },{email} = {}){
    return axios.post(FORGET_CLIENT_ENDPOINT, { email }).then(response => {
      const client = response.data
      // console.log(client)
      // commit('SET_CURRENT_USER', user)
      return client
    })
  },
  forgetDriver({ commit,dispatch },{ username} = {}){
    return axios.post(FORGET_ENDPOINT, { username }).then(response => {
      const user = response.data
      // console.log(user)
      // commit('SET_CURRENT_USER', user)
      return user
    })
  },

  resetUserPassword({commit,dispatch},{password,passwordconfirm,token} = {}){
    // window.location.pathname.split("/").pop()
    // USER RESET
    // console.log("yes")
    return axios.post(RESET_ENDPOINT+token,{password}).then(response =>{
      return response.data
    })
  },
  resetDriverPassword({commit,dispatch},{password,passwordconfirm,token} = {}){
    // window.location.pathname.split("/").pop()
    // USER RESET
    return axios.post(RESET_DRIVER_ENDPOINT+token,{password}).then(response =>{
      return response.data
    })
  },
  resetClientPassword({commit,dispatch},{password,passwordconfirm,token} = {}){
    // window.location.pathname.split("/").pop()
    // USER RESET
    return axios.post(RESET_CLIENT_ENDPOINT+token,{password}).then(response =>{
      return response.data
    })
  }
}
